<template>
  <v-container class="fill-height">
    <v-row
      v-if="error.error === 'access_denied' && error.error_description"
      justify="center"
      style="align-self: end"
    >
      <h1>{{ error.error_description }}</h1>
    </v-row>
    <v-row v-else>
      <h1>Unable to login to IronSight</h1>
    </v-row>
    <v-row justify="center" style="align-self: start; margin-top: 30px">
      <vs-button data-test="logout" label="Log out" @click="handleLogout" />
      <vs-button
        data-test="get-support"
        type="secondary"
        label="Get support"
        style="margin-left: 15px"
        @click="navigateToSupportPage"
      />
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { getInstance } from '@/auth/auth.js'

const auth = getInstance()

defineProps<{
  error: Error
}>()

const handleLogout = () => {
  auth.logout()
}
const navigateToSupportPage = () => {
  window.open('https://ironsight.app/support-resources', '_blank')
}
</script>
